<template>
  <div class="container">
    <div class="content-wrapper">
<!--      <div class="page-header">-->
<!--        <h1>知识库</h1>-->
<!--        <div class="page-subtitle">专业的设备维修知识库，涵盖故障诊断、维修技巧、保养方法等全方位知识</div>-->
<!--      </div>-->

      <!-- 整体卡片（标签 + 内容 / 详情） -->
      <div class="card">
        <!-- 详情视图：整张卡片切换 -->
        <div v-if="activeArticle" class="card-body card-body-content">
          <div class="article-detail">
            <button type="button" class="article-back-btn" @click="backToList">
              <el-icon>
                <ArrowLeft />
              </el-icon>
              <span>返回列表</span>
            </button>

            <!-- 针对 SUP-300 的文章详情 -->
            <div v-if="activeArticle.id === 1" class="article-detail-content">
                  <h2 class="article-detail-title">SUP-300开机报错error jam维修说明</h2>

                  <section class="article-section">
                    <h3>故障现象</h3>
                    <p>用户保修说开机就报错 error jam，且机器内部无卡。通过 demo 查询传感器状态。</p>
                    <p>（1）打印机前面屏幕报错 error jam：</p>
                    <img class="article-image" src="https://wiseagent.oss-cn-shanghai.aliyuncs.com/client/upload/image/20251213110315555_tmp_baa572ce2eecdb85b0090049c35e750444c6e8e1e6348878.jpg" alt="屏幕报错">
                    <p>（2）查看所有传感器状态截图：</p>
                    <img class="article-image" src="https://wiseagent.oss-cn-shanghai.aliyuncs.com/client/upload/image/20251213110321627_tmp_4665ad0cc8cd8e662e1157a27afcf917e156cf872640ee97.jpg" alt="传感器状态">
                  </section>

                  <section class="article-section">
                    <h3>故障原因</h3>
                    <p>由屏幕提示可知：设备检测到卡在机器内部发生阻塞。</p>
                    <p>经客户确认机器内部无卡，但传感器状态中显示后出卡口有卡，因此判断为：</p>
                    <ul>
                      <li>后出卡口传感器检测状态异常；</li>
                      <li>清理后故障依旧，传感器本体故障。</li>
                    </ul>
                    <p><strong>最终结论：更换后出卡口传感器。</strong></p>
                  </section>

                  <section class="article-section">
                    <h3>解决方案</h3>
                    <h4>一、更换出卡口传感器</h4>
                    <ol>
                      <li>
                        关闭打印机电源，打开打印机盖，拆除顶部的四个螺丝，关上打印机盖。
                        <div class="article-image-row">
                          <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_01.png" alt="打开机盖">
                          <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_02.png" alt="关闭机盖">
                        </div>
                      </li>
                      <li>翻转打印机，拆除底部的四个螺丝。</li>
                      <li>
                        放正打印机，打开机盖，取出打印机的左右盖，并拔掉开机键的排线。
                        <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_03.png" alt="拔掉排线">
                      </li>
                      <li>
                        卸掉后盖的四个螺丝，并取出后盖。
                        <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_04.png" alt="拆除后盖螺丝">
                      </li>
                      <li>
                        取下轨道出卡传感器排线。
                        <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_05.png" alt="取下传感器">
                      </li>
                      <li>
                        更换传感器，并装上传感器固定螺丝。
                        <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_06.png" alt="装上传感器">
                      </li>
                      <li>
                        装上后盖，装好开机排线。
                        <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_07.png" alt="装上后盖">
                      </li>
                      <li>
                        安装左右侧盖并固定螺丝。
                        <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_08.png" alt="装上左右盖的螺丝">
                      </li>
                    </ol>

                    <h4>二、验证：打印测试卡</h4>
                    <ol>
                      <li>
                        打印机接好电源开机，当指示灯变为绿灯时放入测试卡。
                        <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/error_jam_08.png" alt="打开打印机">
                      </li>
                      <li>电脑上打印机首选项选择“状态维护”标签，点击“打印设置”，在弹出的打印校准对话框中点击“读参数”。</li>
                      <li>
                        读取参数完成后，在右侧选择“半格色带”，然后点击“打印测试卡”。
                        <img class="article-image" src="https://hotcardossmedia.oss-cn-beijing.aliyuncs.com/Fin/Suprint/SUP-300/pic/sup300%E7%BB%B4%E4%BF%9D06.png" alt="检查测试卡">
                      </li>
                      <li>等待打印完成，打印机吐出卡片，检查测试卡打印是否清晰、无报错。</li>
                    </ol>
                  </section>
            </div>

            <!-- 其他文章的通用详情占位（暂时简单展示） -->
            <div v-else class="article-detail-content">
              <h2 class="article-detail-title">{{ activeArticle.title }}</h2>
              <div class="article-meta">
                <span :class="['article-tag', `article-tag-${activeArticle.difficulty}`]">
                  {{ activeArticle.difficultyText }}
                </span>
                <span class="article-tag article-tag-time">{{ activeArticle.duration }}</span>
                <span class="article-tag article-tag-read">{{ activeArticle.reads }} 阅读</span>
                <span class="article-tag article-tag-rating">
                  <el-icon>
                    <StarFilled />
                  </el-icon>
                  {{ activeArticle.rating }}
                </span>
              </div>
              <div class="article-description article-detail-description">
                {{ activeArticle.description }}
              </div>
              <div class="article-tags">
                <span
                    v-for="tag in activeArticle.tags"
                    :key="tag"
                    class="article-tag-item"
                >{{ tag }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 列表视图：标签 + 列表一并显示在卡片内 -->
        <template v-else>
          <!-- 分类标签 -->
          <div class="card-body card-body-tabs">
            <div class="tabs-wrapper">
              <div
                  v-for="category in categories"
                  :key="category.key"
                  :class="['tab-item', { 'tab-item-active': activeTab === category.key }]"
                  @click="handleTabClick(category.key)"
              >
                {{ category.label }}
              </div>
            </div>
          </div>

          <!-- 知识库内容 -->
          <div v-for="category in categories" :key="category.key">
            <div v-if="activeTab === category.key" class="knowledge-content">
              <div class="card-body card-body-content">
                <ul class="article-list">
                  <li
                      v-for="article in category.articles"
                      :key="article.id"
                      class="article-item"
                  >
                    <div class="article-content">
                      <h4 class="article-title">
                        <strong>{{ article.title }}</strong>
                      </h4>
                      <div class="article-meta">
                        <span :class="['article-tag', `article-tag-${article.difficulty}`]">
                          {{ article.difficultyText }}
                        </span>
                        <span class="article-tag article-tag-time">{{ article.duration }}</span>
                        <span class="article-tag article-tag-read">{{ article.reads }} 阅读</span>
                        <span class="article-tag article-tag-rating">
                          <el-icon>
                            <StarFilled />
                          </el-icon>
                          {{ article.rating }}
                        </span>
                      </div>
                      <div class="article-description">{{ article.description }}</div>
                      <div class="article-tags">
                        <span
                            v-for="tag in article.tags"
                            :key="tag"
                            class="article-tag-item"
                        >{{ tag }}</span>
                      </div>
                    </div>
                    <div class="article-action">
                      <button type="button" class="article-btn" @click="openArticle(article, category)">
                        <el-icon>
                          <Reading />
                        </el-icon>
                        <span>阅读</span>
                      </button>
                    </div>
                  </li>
                </ul>

                <!-- 更多内容提示 -->
                <div class="placeholder-content">
                  <div class="placeholder-text">更多内容开发中...</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  padding-top: 12rem;
  background: #f5f6fa;
}

.content-wrapper {
  margin: auto;
  width: 60rem;
  padding: 1.5rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.page-subtitle {
  font-size: 1rem;
  color: #666;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.card-disabled {
  opacity: 0.3;
}

.card-body {
  padding: 1.5rem;
}

.card-body-tabs {
  border-bottom: 1px solid #f0f0f0;
}

.card-body-content {
  padding-top: 1.25rem;
}

/* 详情视图 */
.article-detail {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.article-detail-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  text-align: center;
}

.article-section {
  margin-bottom: 1.5rem;
}

.article-section h3 {
  font-size: 1.25rem;
  margin: 0 0 0.75rem 0;
  color: #333;
}

.article-section h4 {
  font-size: 1.1rem;
  margin: 1rem 0 0.5rem 0;
  color: #444;
}

.article-section p {
  margin: 0 0 0.5rem 0;
  color: #555;
  line-height: 1.7;
}

.article-section ul,
.article-section ol {
  margin: 0 0 0.75rem 1.25rem;
  padding: 0;
}

.article-section li {
  margin-bottom: 0.4rem;
  line-height: 1.6;
}

.article-image {
  display: block;
  max-width: 100%;
  margin: 0.75rem auto;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.article-image-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.article-image-row .article-image {
  flex: 1 1 45%;
  max-width: 45%;
}

.article-detail-description {
  margin-top: 0.75rem;
}

.article-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
  padding: 0;
  font-size: 0.875rem;
  border: none;
  background: transparent;
  color: #666;
  cursor: pointer;
  transition: color 0.2s;
}

.article-back-btn:hover {
  color: #1890ff;
}

/* 标签页 */
.tabs-wrapper {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.tab-item {
  padding: 0.75rem 1.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.tab-item:hover {
  color: #1890ff;
  background: #e6f7ff;
}

.tab-item-active {
  color: #1890ff;
  background: #e6f7ff;
  border-color: #1890ff;
}

/* 分类头部 */
.category-header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 0;
}

.category-header h2 {
  font-size: 2.25rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #1890ff;
}

.category-header p {
  font-size: 1.125rem;
  color: #666;
  width: 50rem;
  margin: 0 auto;
}

/* 文章列表 */
.article-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.article-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 1.25rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background: #fafafa;
  transition: all 0.3s;
}

.article-item:hover {
  border-color: #1890ff;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
}

.article-content {
  flex: 1;
}

.article-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
  color: #1890ff;
}

.article-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.article-tag {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
}

.article-tag-easy {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.article-tag-medium {
  background: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}

.article-tag-hard {
  background: #fff1f0;
  color: #ff4d4f;
  border: 1px solid #ffccc7;
}

.article-tag-time {
  background: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.article-tag-read {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.article-tag-rating {
  background: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.article-description {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
  margin-bottom: 0.75rem;
}

.article-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.article-tag-item {
  display: inline-block;
  padding: 0.125rem 0.5rem;
  background: #fafafa;
  color: #666;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 0.8125rem;
}

.article-action {
  margin-left: 1rem;
  flex-shrink: 0;
}

.article-btn {
  padding: 0.5rem 1rem;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s;
}

.article-btn:hover {
  background: #40a9ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
}

.article-btn svg {
  width: 1em;
  height: 1em;
}
</style>

<script setup>
import {ref} from 'vue'
import { ElIcon } from 'element-plus'
import { StarFilled, Reading, ArrowLeft } from '@element-plus/icons-vue'

const activeTab = ref('smart-home')
// 当前阅读的文章
const activeArticle = ref(null)
const activeArticleCategoryKey = ref(null)

const categories = ref([
  {
    key: 'smart-home',
    label: '桌面制卡机',
    title: '智能家电维修知识库',
    description: '专业的智能家电维修指南，涵盖故障诊断、维修技巧、保养方法等全方位知识',
    articles: [
      {
        id: 1,
        title: 'SUP-300开机报错error jam维修说明',
        description: '详细分析SUP-300的可能原因，提供完整的故障排查流程和维修方案。',
        difficulty: 'medium',
        difficultyText: '中等',
        duration: '30分钟',
        reads: 1250,
        rating: 4.8,
        tags: ['故障诊断', 'SUP-300', '传感器']
      }
    ]
  },
  {
    key: 'financial',
    label: '便携制卡机',
    title: '金融设备维修知识库',
    description: '专业的金融设备维修指南，涵盖ATM机、点钞机、验钞机等设备的故障诊断和维修方法',
    articles: []
  },
  {
    key: 'drone',
    label: '自助制卡机',
    title: '无人机维修知识库',
    description: '专业的无人机维修指南，涵盖飞行器故障、电池维护、电机维修等全方位知识',
    articles: []
  }
])

// 标签点击时，顺便关闭详情视图
function handleTabClick(key) {
  activeTab.value = key
  activeArticle.value = null
  activeArticleCategoryKey.value = null
}

// 打开文章详情
function openArticle(article, category) {
  activeArticle.value = article
  activeArticleCategoryKey.value = category.key
}

// 返回列表视图
function backToList() {
  activeArticle.value = null
  activeArticleCategoryKey.value = null
}

</script>
